import { render, staticRenderFns } from "./LogisticsCenter.vue?vue&type=template&id=5b8acd35&scoped=true&"
import script from "./LogisticsCenter.vue?vue&type=script&lang=js&"
export * from "./LogisticsCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8acd35",
  null
  
)

export default component.exports